<template>
  <v-container>
    <v-toolbar color="white" dark flat dense cad>
      <v-toolbar-title class="indigo--text">Panel de Control</v-toolbar-title>
    </v-toolbar>
    <v-form>
      <v-container>
        <div class="contenedorPanel">
          <div class="colPanel" v-for="column in columns">
            <div class="contenedorModulo" v-for="modulo in column">
              <v-switch
                :label="`${modulo.procesoModulo.descripcion}`"
                :input-value="modulo.estado"
                @change="cambiarValor(modulo.id)"
              ></v-switch>
            </div>
          </div>
        </div>
      </v-container>
      <div v-if="loading">
        <loading></loading>
      </div>
    </v-form>
    <v-card-actions class="pb-3">
      <v-btn color="primary" dark class="mb-2" @click="guardarPanel()">
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-container>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
export default {
  name: "panel-control-tab",
  components: {
    Loading,
  },
  props: {},
  data() {
    return {
      idContrato: "",
      loading: false,
      modulos: [],
      editados: [], //para guardar solo elementos que han sido modificados
      cols: 2,
    };
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.loadDataPanel();
  },
  mounted() {},
  computed: {
    columns() {
      let columns = [];
      if (this.modulos) {
        //determina en que columna se mostrara cada modulo
        let mid = Math.ceil(this.modulos.length / this.cols);
        for (let col = 0; col < this.cols; col++) {
          columns.push(this.modulos.slice(col * mid, col * mid + mid));
        }
      }
      return columns;
    },
  },
  methods: {
    async loadDataPanel() {
      this.loading = true;
      this.modulos = await this.loadPanel();
      this.loading = false;
    },
    async loadPanel() {
      return await axios
        .get("/panelControl/" + this.idContrato)
        .then(function (response) {
          //console.log('response:' + response.data);
          return response.data;
        })
        .catch(function (error) {
          window.getApp.$emit("APP_PROCESS_ERROR");
          console.log("error loadPanel:" + error);
          return [];
        });
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
    cambiarValor(idModulo) {
      for (let i = 0; i < this.modulos.length; i++) {
        if (this.modulos[i].id == idModulo) {
          this.editados.push(idModulo);
          this.modulos[i].estado = !this.modulos[i].estado;
          return;
        }
      }
    },
    async guardarPanel() {
      this.loading = true;
      if (this.editados.length > 0) {
        await this.guardarCambios();
        this.editados = [];
      }
      this.loading = false;
    },
    async guardarCambios() {
      // filtra para guardar solo elementos modificados
      const idsEditados = this.editados.filter((valor, indice) => {
        return this.editados.indexOf(valor) === indice;
      });
      let toSave = [];
      for (let i = 0; i < idsEditados.length; i++) {
        for (let j = 0; j < this.modulos.length; j++) {
          if (this.modulos[j].id == idsEditados[i]) {
            toSave.push(this.modulos[j]);
            continue;
          }
        }
      }

      axios
        .put(
          "/panelControl/" +
            this.idContrato +
            "/" +
            this.$store.getters.userLogged.id,
          toSave
        )
        .then((response) => {
          this.resp = response.data;
          //console.log("response update:" + response.data);
          window.getApp.$emit("APP_SAVE");
          this.dialogAsig = false;
          this.reload();
        })
        .catch(function (error) {
          window.getApp.$emit("APP_PROCESS_ERROR");
          console.log("error guardarPanel:", error.response.data.message);
          console.log("error update:" + error);
        });
    },
  },
};
</script>
<style>
.contenedorPanel {
  display: flex;
  border: 0px solid;
}
.colPanel {
  margin: 10px;
  border: 0px solid;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.contenedorModulo {
  border: 0px solid;
  padding: 5px;
  margin: 5px;
}
</style>
